<template>
  <div class="row justify-content-md-center">
    <div class="col-12 mb-3 text-center">
      <h3 class="m-1">Califica el sistema</h3>
      <el-rate v-model="data.rate"></el-rate>
    </div>
    <div class="col-12">
      <textarea class="form-control bg-white" v-model="data.observaciones" placeholder="Observaciones"> </textarea>
    </div>
    <div class="col-12 mt-3 d-flex justify-content-center">
      <button type="button" class="text-center btn btn-secondary" data-dismiss="modal" @click="send" :disabled="(data.rate != 0)?false:true">Enviar</button>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["data"],
    data() {
      return {

      };
    },
    methods: {
      send() {
        console.log("ok");
      }
    },
  };

</script>
<style>
  .el-rate__icon {
    font-size: 30px !important;

  }

  .el-rate {
    height: 30px !important;
    line-height: 30px !important;
  }

  .btn:disabled {
    color: #d6d6d6;
  }

</style>



// WEBPACK FOOTER //
// src/components/Rating.component.vue